import { CSSProperties } from "react";
import { useSelect } from "downshift";

export type SelectProps<T> = {
  selectedItem: T | null;
  setSelectedItem: (item: T | null) => void;
  items: T[];
  itemToString: (item: T | null) => string;
  itemIsSelected: (item: T) => boolean;
  placeholder?: string;
  itemKey: keyof T;
  toggleStyle?: CSSProperties;
  toggleClassName?: string;
  menuStyle?: CSSProperties;
  menuClassName?: string;
  listItemClassName?: string;
  listItemStyle?: CSSProperties;
};

export default function Select<T>(props: SelectProps<T>) {
  const {
    items,
    toggleStyle,
    toggleClassName,
    menuStyle,
    menuClassName,
    itemIsSelected,
    itemKey,
    itemToString,
    listItemClassName,
    listItemStyle,
    placeholder,
    selectedItem,
    setSelectedItem,
  } = props;

  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    highlightedIndex,
    getItemProps,
  } = useSelect({
    items,
    itemToString,
    onSelectedItemChange: (changes) => {
      const { selectedItem } = changes;
      setSelectedItem(selectedItem);
    },
  });

  return (
    <div className="select position-relative">
      <button
        aria-label={placeholder ?? "Vælg"}
        className={`select kommune-combobox-input w-100 ${isOpen ? "is-open" : ""} ${
          toggleClassName ?? ""
        }`}
        style={toggleStyle}
        {...getToggleButtonProps()}
      >
        {selectedItem && itemToString(selectedItem)
          ? itemToString(selectedItem)
          : (placeholder ?? "Vælg")}
      </button>
      <ul
        className={`kommune-combobox-ul  ${!isOpen && "hidden"} ${
          menuClassName ?? ""
        }`}
        style={menuStyle}
        {...getMenuProps()}
      >
        {isOpen &&
          items.map((item, index) => (
            <li
              className={`filtermenuitem ${
                highlightedIndex === index ? "active " : ""
              } ${itemIsSelected(item) ? "active" : ""} ${listItemStyle} ${listItemClassName ?? ""}`}
              key={`${item[itemKey]}${index}`}
              style={listItemStyle}
              {...getItemProps({ item, index })}
            >
              <span>{itemToString(item)}</span>
            </li>
          ))}
      </ul>
    </div>
  );
}
